import * as React from 'react';
import { TableCell } from '@telia-front/table';
import Term from './term';
import { cellBEM } from './utils';
const DataCell = (props) => {
    const { data, isMobile = false, categoryItem, width = 2 } = props;
    if (isMobile && categoryItem) {
        return (React.createElement(TableCell, { className: cellBEM(categoryItem.isDifferent), valign: "top", width: width },
            React.createElement(Term, { label: React.createElement(React.Fragment, null,
                    categoryItem.label,
                    categoryItem.labelAside && (React.createElement(React.Fragment, null,
                        "\u00A0",
                        categoryItem.labelAside))) }, data && React.createElement(DataCellContent, { data: data, isMobile: isMobile }))));
    }
    return (React.createElement(TableCell, { className: cellBEM(data === null || data === void 0 ? void 0 : data.isDifferent), width: width }, data && React.createElement(DataCellContent, { data: data })));
};
const DataCellContent = (props) => {
    const { data, isMobile = false } = props;
    return (React.createElement("div", { className: detailItemBEM(data, isMobile) },
        data.value || '-',
        " ",
        data.priceUnit && data.priceUnit));
};
const detailItemBEM = (item, isMobile = false) => {
    const classArray = [];
    if (((item.normalPrice || item.priceUnit) && !isMobile) || (item.priceUnit && !item.normalPrice)) {
        classArray.push('text-bold');
    }
    if (item.normalPrice) {
        classArray.push('text-light');
    }
    if (item.isMissing || typeof item.value === 'undefined') {
        classArray.push('text-light');
    }
    return classArray.join(' ');
};
export default DataCell;
